import { render } from "./TroopsOverview.vue?vue&type=template&id=5a0bb5ac"
import script from "./TroopsOverview.vue?vue&type=script&lang=js"
export * from "./TroopsOverview.vue?vue&type=script&lang=js"

import "./TroopsOverview.vue?vue&type=style&index=0&id=5a0bb5ac&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TroopsOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a0bb5ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a0bb5ac', __exports__)) {
    api.reload('5a0bb5ac', __exports__)
  }
  
  module.hot.accept("./TroopsOverview.vue?vue&type=template&id=5a0bb5ac", () => {
    api.rerender('5a0bb5ac', render)
  })

}


export default __exports__